import { render, staticRenderFns } from "./orgdetail.vue?vue&type=template&id=23ff50f4&"
import script from "./orgdetail.vue?vue&type=script&lang=js&"
export * from "./orgdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports